import { createSlice } from "@reduxjs/toolkit";
import { getHelpCenterData } from "./_helpCenterAction";


interface ManageHelpCenterState {
  helpCenterData: {};
  loading: boolean;
  error: string | null;
}

const initialState: ManageHelpCenterState = {
  helpCenterData: {},
  loading: false,
  error: null,
};


export const helpCenterReducer = createSlice({
  name: "helpCenter",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch help center data
      .addCase(getHelpCenterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHelpCenterData.fulfilled, (state, action) => {
        state.loading = false;
        state.helpCenterData = action.payload?.data;
      })
      .addCase(getHelpCenterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = helpCenterReducer.actions;
export default helpCenterReducer;